import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const postUser = async (user: AdminTypes.NewUser) => {
  const res = await Api.post<AdminTypes.User>('/admin/v1/users', user);
  return res.data;
};
